<template>
    <div id="plan">
        <div class="plan-home">
            <img src="../../../assets/image/plan1.jpg" alt="">
            <!-- <img src="../../../assets/image/plan2.jpg" alt="">
            <img src="../../../assets/image/plan3.jpg" alt=""> -->
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            
        }
    }
}
</script>
<style lang="scss" scoped>
    #plan{
        width: 100%;

        .plan-home{
            padding: 0 110px 30px 110px; 
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
</style>